import styled from "styled-components";
import ListWithPagination from "../ListsWithPagination";
import { TableWithPagination } from "../TableWithPagination";

interface Props {
  data: any[];
  currentPage: number;
  totalData: number;
  rowsPerPage: number;
  isTableDataLoading: boolean;
  onPageChange: (page: number) => void;
}

const TransactionTable = ({
  data,
  isTableDataLoading,
  totalData,
  currentPage,
  rowsPerPage,
  onPageChange,
}: Props) => {
  const columns = [
    {
      path: "cardId",
      label: "Card ID",
    },
    {
      path: "transactionAmount",
      label: "Transaction Amount",
    },
    {
      path: "transactionDateandTime",
      label: "Transaction Date & Time",
    },
    {
      path: "merchantID",
      label: "Merchant ID",
    },
    {
      path: "merchantName",
      label: "Merchant Name",
    },
  ];
  return (
    <>
      <TableWrapper>
        <TableWithPagination
          onPageChange={onPageChange}
          totalData={totalData}
          currentPage={currentPage}
          rowsPerPage={rowsPerPage}
          columns={columns}
          data={data}
          isTableDataLoading={isTableDataLoading}
        />
      </TableWrapper>
      <ListWrapper>
        <ListWithPagination
          onPageChange={onPageChange}
          totalData={totalData}
          currentPage={currentPage}
          rowsPerPage={rowsPerPage}
          columns={columns}
          data={data}
          isTableDataLoading={isTableDataLoading}
          title={"Topup Transaction details"}
        />
      </ListWrapper>
    </>
  );
};

const ListWrapper = styled.div`
  display: none;
  @media only screen and (max-width: 768px) {
    display: block;
  }
`;

const TableWrapper = styled.div`
  @media only screen and (max-width: 768px) {
    display: none;
  }
`;

export default TransactionTable;
